<div class="ng-file-upload clr-wrapper">
    <div
        class="ng-file-upload__file-label-container"
        [ngClass]="{
            'ng-file-upload__file-label-container--disabled': disabled && !showCancel,
            'ng-file-upload__file-label-container--uploading': showCancel
        }"
    >
        <span
            class="ng-file-upload__file-label sel-file-label"
            [ngClass]="{'ng-file-upload__file-label--without-value': !fileName}"
        >
            {{ fileLabel }}
        </span>
        <cds-icon
            *ngIf="fileName && !showCancel"
            class="ng-file-upload__clear-icon"
            shape="times-circle"
            size="20"
            (click)="removeUploadedFile()"
            (keydown.enter)="removeUploadedFile()"
            (keydown.space)="removeUploadedFile()"
        ></cds-icon>
        <cds-button
            *ngIf="showCancel"
            class="ng-file-upload__cancel-button"
            size="sm"
            action="flat-inline"
            (click)="cancelUpload()"
            (keydown.enter)="cancelUpload()"
            (keydown.space)="cancelUpload()"
        >
            {{ globalL10nKeys.cancelLabel | vtranslate }}
        </cds-button>
    </div>

    <cds-button
        action="{{ buttonAction }}"
        size="sm"
        [loadingState]="buttonLoadingState"
        [disabled]="disabled"
        (click)="invokeFileUpload()"
    >
        {{ buttonLabel }}
    </cds-button>

    <input
        class="ng-file-upload__input sel-file-upload"
        type="file"
        (change)="startFileLoad($event)"
        [disabled]="busy || disabled"
        #fileUploadElementRef
        [attr.accept]="accept"
    />
</div>
